import DOMPurify from 'dompurify';
import { cn } from '@/lib/utils';

export interface RichTextProps {
  html: string;
  className?: string;
}

// Client-side defense-in-depth over the authoritative server (nh3) sanitization.
const ALLOWED_TAGS = [
  'b', 'strong', 'i', 'em', 'u', 'br', 'p',
  'ul', 'ol', 'li', 'h1', 'h2', 'h3',
  'a', 'table', 'thead', 'tbody', 'tr', 'td', 'th',
];

/** Read-only renderer for a sanitized rich-text answer body. */
export function RichText({ html, className }: RichTextProps) {
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ['href', 'rel'],
  });
  return (
    <div
      className={cn(
        'prose prose-sm max-w-none text-sm text-foreground',
        '[&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-5 [&_ol]:pl-5',
        '[&_table]:border-collapse [&_td]:border [&_th]:border [&_td]:px-1.5 [&_th]:px-1.5',
        className
      )}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
